<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="info.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="75%"
  >
    <div>
      <el-form
        class="ruleForm"
        :inline="true"
        :model="ruleform"
        size="small"
        label-width="80px"
      >
        <el-form-item label="学院名称：">
          {{ detailInfo.deptName }}
        </el-form-item>
        <div></div>
        <el-form-item label="干部级别：" class="select_btn_200">
          <el-select
            clearable
            multiple
            collapse-tags
            v-model="ruleform.cadreLevels"
            placeholder="全部"
          >
            <el-option
              v-for="(item, i) in cadreLevelData"
              :key="i"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理主体：">
          <el-select
            clearable
            multiple
            collapse-tags
            v-model="ruleform.userLeaderTypes"
            placeholder="全部"
          >
            <el-option
              v-for="(item, i) in leaderTypeData"
              :key="i"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户状态：" class="select_btn_120">
          <el-select v-model="ruleform.userStatus" placeholder="用户状态">
            <el-option
              v-for="(item, i) in userStatusData"
              :key="i"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考核状态：" class="select_btn_120">
          <el-select v-model="ruleform.examStatus" placeholder="考核状态">
            <el-option
              v-for="(item, i) in publicData"
              :key="i"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="浙政钉绑定状态："  label-width="120px">
          <el-select v-model="ruleform.bindStatus" placeholder="全部" class="select_btn_140">
            <el-option
              v-for="(item, i) in bindStatusData"
              :key="i"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="onComfrim()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
import { saveLiveRoomRule, getLiveRoomRuleInfo } from "@/api/resourceService";

export default {
  components: { butn },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          show: false,
          uuid: "",
          liveRoomId: ""
        };
      },
    },
  },
  data() {
    return {
      curdTitle: "编辑授权范围",
      ruleform: {
        userLeaderTypes: [],
        examStatus: "",
        userStatus: "",
        cadreLevels: [],
      },
      detailInfo: {},
      userStatusData: [],
      leaderTypeData: [],
      publicData: [],
      cadreLevelData: [],
      bindStatusData: [],
    };
  },
  created() {
    this.getLiveRoomRuleInfo();
    this.getSysParamByTypes(["USER_LEADER_TYPE", "USER_STATUS", "EXAM_STATUS", "CADRE_LEVEL", "USER_BIND_STATUS"]);
  },
  methods: {
    // 详情
    getLiveRoomRuleInfo() {
      getLiveRoomRuleInfo(this.info.uuid).then((res) => {
        if (!res || res.code != 0) return;
        this.detailInfo = res.data;
        this.ruleform.cadreLevels = res.data.cadreLevels;
        this.ruleform.userLeaderTypes = res.data.userLeaderTypes;
        this.ruleform.examStatus = res.data.examStatus;
        this.ruleform.userStatus = res.data.userStatus;
        this.ruleform.bindStatus = res.data.bindStatus;
      });
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // res.data["USER_LEADER_TYPE"].splice(0, 0, {
        //   paramKey: "",
        //   paramValue: "全部",
        // });
        res.data["USER_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["EXAM_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["USER_BIND_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.leaderTypeData = res.data["USER_LEADER_TYPE"];
        this.userStatusData = res.data["USER_STATUS"];
        this.publicData = res.data["EXAM_STATUS"];
        this.cadreLevelData = res.data["CADRE_LEVEL"];
        this.bindStatusData = res.data["USER_BIND_STATUS"];
      });
    },
    onComfrim() {
      saveLiveRoomRule({
        liveRoomId: this.info.liveRoomId,
        deptIds: [this.detailInfo.deptId],
        ...this.ruleform,
      }).then((res) => {
        if (res && res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("closeDialog", true);
        }
      });
    },
    closeDialog() {
      this.$emit("closeDialog", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.radioGroup {
  display: flex;
  flex-direction: column;
  .m-t-40 {
    margin-top: 40px;
  }
}
.select_btn_120 {
  // width: 200px;
  /deep/.el-input__inner {
    width: 110px;
  }
}
.select_btn_200 {
  /deep/.el-input__inner {
    width: 220px;
  }
}
</style>
